// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__IBb0b","default":"secondaryButton_default__rzw7b","active":"secondaryButton_active__OpfqF"};